
































































































































































































































































import * as _ from "lodash";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {
  GetPatientAllTongue,
  GetTongueDetail,
  SaveTongueDetail,
  GetOssParams,
} from "@/request/tongue";
import * as OSS from "ali-oss";
import PicCanvas from "./pic-canvas/pic-canvas.vue";
import Sheti from "./sheti.vue";
import Shetai from "./shetai.vue";
import Fenzu from "./fenzu.vue";
import Fenge from "./pic-canvas/fenge.vue";
@Component({
  components: {
    PicCanvas,
    Sheti,
    Shetai,
    Fenzu,
    Fenge,
  },
})
export default class IdrTongueBiaozhu extends Vue {
  private tongueId: any = "";
  private options: any = {};
  private currentPicSrc: any = "";
  private tongue: any = {
    patient_id: "",
    舌象照片: {},
    轨迹: {},
  };
  private tongues: any[] = [];
  private model: any = "";
  private picType: any = "origin";
  private cPart: any = "望舌体";
  private ifShowBidui: boolean = false;
  private loaded: boolean = false;
  private ifOpenFenge: boolean = false;
  private kuankuanbiHelp: boolean = false;
  private ossReady: boolean = false;
  private get ossClient() {
    return this.$store.state.ossClient;
  }
  private get picCanvas() {
    return this.$refs.picCanvas as any;
  }
  @Watch("$route.query", { immediate: true, deep: true })
  private queryChange() {
    // this.ossReady = false;
    this.tongueId = this.$route.query.tongue_id;
    this.fetchDetail().then(() => {
      this.fetchPatientAllTongue();
      if (this.$route.query.part) {
        switch (this.$route.query.part) {
          case "几何":
            (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
            break;
          case "分组":
            this.changePart("分组");
            break;
        }
      }
    });
    // this.createOss().then(() => {
    //   this.ossReady = true;
    // });
  }
  /**
   * @description 跳转智能比对
   */
  private jumpBidui() {
    localStorage.setItem("selectedTongues", JSON.stringify([this.tongue]));
    this.$router.push("/main/tongue/bidui-list");
  }
  /**
   * @description 保存
   */
  private save() {
    console.log(this.tongue);
    const params: any = _.cloneDeep(this.tongue);
    SaveTongueDetail(this, params).then((data: any) => {
      this.$message.success("标注成功");
    });
  }
  /**
   * @description 获得该患者的全部舌图
   */
  private fetchPatientAllTongue() {
    const params: any = {
      params: {
        patient_id: this.tongue.patient_id,
      },
    };
    GetPatientAllTongue(this, params).then((data: any) => {
      // console.log(data);
      this.tongues = data;
    });
  }
  /**
   * @description 获得详情
   */
  private fetchDetail() {
    this.loaded = false;
    return new Promise((resolve, reject) => {
      const params: any = {
        params: {
          tongue_id: this.tongueId,
        },
      };
      GetTongueDetail(this, params)
        .then((data: any) => {
          console.log(data);
          if (!data["轨迹"]) {
            data["轨迹"] = {};
          }
          this.tongue = data;
          this.currentPicSrc = this.tongue["舌象照片"]["分割前图片"];
          this.loaded = true;
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 返回列表
   */
  private backList() {
    this.$router.push("/main/tongue/tongue-list");
  }
  /**
   * @description 跳转舌图预览
   */
  private jumpTonguePreview() {
    this.$router.push({
      path: "/main/tongue/tongue-preview",
      query: {
        tongue_id: this.tongue.tongue_id,
      },
    });
  }
  /**
   * @description 切换同一个患者的其他舌图
   */
  private changeTongue(tongue) {
    this.$router.push({
      path: "/main/tongue/biaozhu-detail",
      query: {
        tongue_id: tongue.tongue_id,
      },
    });
  }
  /**
   * @description 切换展示的图片
   */
  private changeCurrentPic(src, model) {
    this.currentPicSrc = src;
    this.picType = model;
  }
  // 图像标注
  /**
   * @description 局部舌色
   */
  private jubushese() {
    this.model = "局部舌色";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).jubusheseScrollToView();
    });
    this.picCanvas.jubushese();
  }
  /**
   * @description 删除局部舌色
   */
  private deleteJubushese() {
    this.picCanvas.deleteJubushese();
  }
  /**
   * @description 局部苔色
   */
  private jubutaise() {
    this.model = "局部苔色";
    this.cPart = "望舌苔";
    this.$nextTick().then(() => {
      (this.$refs.shetai as any).jubutaiseScrollToView();
    });
    this.picCanvas.jubutaise();
  }
  /**
   * @description 删除局部苔色
   */
  private deleteJubutaise() {
    this.picCanvas.deleteJubutaise();
  }

  /**
   * @description 舌上红点
   */
  private sheshanghongdian() {
    this.model = "舌上红点";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    });
    this.picCanvas.sheshanghongdian();
  }
  /**
   * @description 删除舌上红点
   */
  private deleteSheshanghongdian() {
    this.picCanvas.deleteSheshanghongdian();
  }
  /**
   * @description 瘀斑
   */
  private yuban() {
    this.model = "瘀斑";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    });
    this.picCanvas.yuban();
  }
  /**
   * @description 删除某个瘀斑
   */
  private deleteYuban(index) {
    this.picCanvas.deleteYuban(index);
  }
  /**
   * @description 齿痕
   */
  private chihen() {
    this.model = "齿痕";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    });
    this.picCanvas.chihen();
  }
  /**
   * @description 删除某个齿痕
   */
  private deleteChihen(index) {
    this.picCanvas.deleteChihen(index);
  }
  /**
   * @description 裂纹
   */
  private liewen() {
    this.model = "裂纹";
    this.cPart = "望舌体";
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    });
    this.picCanvas.liewen();
  }
  /**
   * @description 删除某个裂纹
   */
  private deleteLiewen(index) {
    this.picCanvas.deleteLiewen(index);
  }
  /**
   * @description 宽宽比
   */
  private kuankuanbi() {
    this.model = "宽宽比";
    this.cPart = "望舌体";
    if (!this.tongue["轨迹"]["宽宽比"]) {
      this.tongue["轨迹"]["宽宽比"] = {
        嘴角间距: {},
        舌间距: {},
      };
    }
    this.$nextTick().then(() => {
      (this.$refs.sheti as any).tezhengbiaozhuScrollToView();
    });
    this.picCanvas.kuankuanbi();
    if (this.kuankuanbiHelp === false && this.picType === "origin") {
      this.$confirm(
        "宽宽比是指嘴角间距和舌两边距离的比值，您可以先在嘴角画一条线，再在舌两边画一条线，系统就会自动得出宽宽比",
        {
          showCancelButton: false,
        }
      );
    }
    this.kuankuanbiHelp = true;
  }
  /**
   * @description 删除宽宽比的某条线
   */
  private deleteKuankuanbi(part) {
    this.picCanvas.deleteKuankuanbi(part);
  }
  /**
   * @description 打开分割弹窗
   */
  private fenge() {
    this.ifOpenFenge = true;
  }
  // 图像操作
  /**
   * @description 移动
   */
  private yidong() {
    this.model = "移动";
    this.picCanvas.yidong();
  }
  /**
   * @description 缩放
   */
  private suofang() {
    this.model = "缩放";
    this.picCanvas.suofang();
  }
  /**
   * @description 放大镜
   */
  private fangdajing() {
    this.model = "放大镜";
    this.picCanvas.fangdajing();
    this.cPart = "望舌苔";
    this.$nextTick().then(() => {
      (this.$refs.shetai as any).jubushetaiScrollToView();
    });
  }
  /**
   * @description 旋转
   */
  private xuanzhuan() {
    this.model = "旋转";
    this.picCanvas.xuanzhuan();
  }
  /**
   * @description 截屏
   */
  private jieping() {
    this.model = "截屏";
    this.picCanvas.jieping();
  }
  /**
   * @description 还原
   */
  private huanyuan() {
    this.model = "还原";
    (this.$refs.sheti as any).huanyuan();
    this.picCanvas.huanyuan();
  }
  /**
   * @description 改变model
   */
  private modelChange(model) {
    this.model = model;
  }
  /**
   * @description 切换显示的部分
   */
  private changePart(part) {
    this.cPart = part;
  }
  /**
   * @description 创建oss
   */
  private createOss() {
    return new Promise((resolve, reject) => {
      GetOssParams(this).then((data: any) => {
        const client = new OSS({
          accessKeyId: data.Credentials.AccessKeyId,
          accessKeySecret: data.Credentials.AccessKeySecret,
          stsToken: data.Credentials.SecurityToken,
          endpoint: data.endpoint,
          bucket: data.bucket,
        });
        this.$store.commit("updateOss", client);
        resolve();
      });
    });
  }
  /**
   * @description 改变局部舌苔放大图
   */
  private jubushetai(url) {
    if (!Array.isArray(this.tongue["局部舌苔放大图"])) {
      this.tongue["局部舌苔放大图"] = [];
    }
    this.tongue["局部舌苔放大图"].push(url);
  }
}
